import React, { useEffect, useState } from 'react';
import * as APIHelper from '../../Helper/apiFetch';
import * as nativeEvents from '../../Helper/native';

const Powerplay = () => {
    const [groups, setGroups] = useState([]);
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        APIHelper.getMerchantList().then(res => {
            if (res?.success && res?.data?.groups) {
                setGroups(res.data.groups);
                setIsActive(res.data.isActive);
            }
        });
    }, []);

    const renderMarquee = (items) => {
        // 84px tile width + 12px gap = 96px per item; keep speed ~96px/s
        const duration = `${items.length * 2}s`;
        return (
            <div className='powerplay-marquee-wrapper'>
                <div className='powerplay-marquee-track' style={{ animationDuration: duration }}>
                    {[...items, ...items].map((merchant, index) => (
                        <div
                            key={index}
                            className='powerplay-cta'
                            style={{ backgroundColor: merchant.imageBgColor }}
                            onClick={() => nativeEvents.goMerchant(merchant.id)}
                        >
                            <img src={merchant.logo} alt={merchant.id} style={{ width: '105px', height: '49px', objectFit: 'contain' }} />
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    // if (!isActive) return null;

    return (
        <div className='powerplay-container'>
            <img className='powerplay' src='https://assets.gosats.io/notification/2026/3/1773723711113' alt='' />
            {
                isActive ? 
                    <div className='powerplay-timer'>
                        ENDING SOON
                    </div>
                    :
                    <div className='powerplay-timer'>
                        POWERPLAY
                    </div>
                
            }
            {groups.map((group, index) => (
                <div key={index} style={{ zIndex: 9 }}>
                    <div className='powerplay-title'>
                        First 6 overs only — <span style={{ fontWeight: 800 }}> {group.type} OFF On <br /> Vouchers </span> up to ₹50! Don't miss it!
                    </div>
                    {isActive ?
                        <div>
                            {group.items?.length > 0 && renderMarquee(group.items)}
                            <button
                            className='powerplay-cta-button'
                            onClick={() => nativeEvents.goToBrandCategory(group.categories?.[0])}
                            >BUY VOUCHERS</button>
                        </div>
                    :
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '16px' }}>
                            <img src='https://assets.gosats.io/notification/2026/3/1774603349921' alt='' style={{maxWidth:'345px', height:'auto'}}/>
                        </div>
                    }
                   
                </div>
            ))}
        </div>
    );
}

export default Powerplay;